import { getRating, rateItem, clearRating } from "@atlas/shared";
import type { RatingItemType, RatingResponse, RatingSummary } from "@atlas/shared";
import { apiClient } from "../lib/api-client";

// Star ratings for collected peaks / trails / landmarks. Detail responses
// embed a RatingSummary; the map inspector fetches one on selection.

export type { RatingItemType, RatingResponse, RatingSummary };

export const ratingQueryKey = (itemType: RatingItemType, itemId: string) =>
  ["ratings", itemType, itemId] as const;

export const fetchRating = (itemType: RatingItemType, itemId: string): Promise<RatingResponse> =>
  getRating(apiClient, itemType, itemId);

export const submitRating = (
  itemType: RatingItemType,
  itemId: string,
  rating: number,
): Promise<RatingResponse> => rateItem(apiClient, itemType, itemId, rating);

export const removeRating = (itemType: RatingItemType, itemId: string): Promise<RatingResponse> =>
  clearRating(apiClient, itemType, itemId);
